module.exports = __webpack_public_path__ + "img/slider-image-02-pluska.503a7e37.png";